import { NumberBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { toPositiveNumber } from './functions/toPositiveNumber';

interface ReserveRateFieldProps {
    /** Locked for sub notes. */
    disabled?: boolean;
}

export const ReserveRateField = ({ disabled = false }: ReserveRateFieldProps) => {
    const value = useStandardLoanStore((state) => state.loan.reserveRate);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <NumberBox
            id='loanReserveRate'
            value={value}
            onChange={(rate) => updateLoan({ reserveRate: toPositiveNumber(rate) })}
            label='Reserve Rate'
            disabled={disabled}
            format="#0.##'%'"
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
